// @flow

import Game from '@/lib/game';

export default class {
  static shouldProcess(game: Game): boolean {
    return true;
  }

  static async process(game: Game) {
    await game.virtualTime.next();
    game.cellManager.process();
    game.unitManager.process();
    game.achievementManager.process();
    game.tutorial.process();
  }
}



// WEBPACK FOOTER //
// ./src/lib/game_event/default_event.js